import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * LWR (Estocástico Rápido Invertido Suavizado, FML.LWR) — painel próprio,
 * 2 linhas: LWR1 e LWR2. yAccessor(d) retorna { lwr1, lwr2 }.
 */
class LWRSeries extends Component {
  constructor(props) {
    super(props);
    this.lwr1Accessor = this.lwr1Accessor.bind(this);
    this.lwr2Accessor = this.lwr2Accessor.bind(this);
  }
  lwr1Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.lwr1;
  }
  lwr2Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.lwr2;
  }
  render() {
    const { strokeLwr1, strokeLwr2, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.lwr1Accessor}
          stroke={strokeLwr1}
          fill="none"
        />
        <LineSeries
          yAccessor={this.lwr2Accessor}
          stroke={strokeLwr2}
          fill="none"
        />
      </g>
    );
  }
}

LWRSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeLwr1: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeLwr2: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

LWRSeries.defaultProps = {
  strokeLwr1: { color: "#FFFF00" },
  strokeLwr2: { color: "#FF0000" },
  className: "react-stockcharts-lwr-series",
};

export default LWRSeries;
